// Dummy authentication data
// In production, this would be stored securely and fetched from a backend

export const dummyUsers = {
  admin: {
    role: 'admin',
    pin: '123456', // 6-digit PIN for admin
    name: 'Admin User',
  },
  waiter: [
    {
      userId: 'waiter001',
      password: 'waiter123',
      role: 'waiter',
      name: 'John Doe',
    },
    {
      userId: 'waiter002',
      password: 'waiter456',
      role: 'waiter',
      name: 'Jane Smith',
    },
  ],
  counter: [
    {
      userId: 'counter001',
      password: 'counter123',
      role: 'counter',
      name: 'Mike Johnson',
    },
    {
      userId: 'counter002',
      password: 'counter456',
      role: 'counter',
      name: 'Sarah Williams',
    },
  ],
  kitchen: [
    {
      userId: 'kitchen001',
      password: 'kitchen123',
      role: 'kitchen',
      name: 'Chef Robert',
    },
    {
      userId: 'kitchen002',
      password: 'kitchen456',
      role: 'kitchen',
      name: 'Chef Maria',
    },
  ],
};

// Authentication helper functions
export const authenticateAdmin = (pin) => {
  return pin === dummyUsers.admin.pin;
};

export const authenticateUser = (role, userId, password) => {
  const users = dummyUsers[role];
  if (!users || !Array.isArray(users)) return null;
  
  const user = users.find(
    (u) => u.userId === userId && u.password === password
  );
  
  return user || null;
};

// Get user info after authentication
export const getUserInfo = (role, credentials) => {
  if (role === 'admin') {
    return dummyUsers.admin;
  }
  
  const user = authenticateUser(role, credentials.userId, credentials.password);
  return user;
};

